import React from "react";

export default function IconSortBa() {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 447.874 447.874"
      style={{ enableBackground: "new 0 0 447.874 447.874" }}>
      <g>
        {/* буква A */}
        <path
          d="M83.719,0c-7.001,14.398-13.75,29.15-20.25,44.25S50.358,75.294,43.657,92.094
			c-6.702,16.8-13.534,34.719-20.531,53.719c-6.998,19-14.387,39.694-22.188,62.094h48.594c2.203-7.202,4.646-14.62,7.344-22.219
			c2.698-7.599,5.337-15.182,7.938-22.781h81c2.6,7.599,5.271,15.182,7.969,22.781s5.14,15.017,7.344,22.219h50.094
			c-7.801-22.4-15.187-43.093-22.188-62.094c-7.001-19-13.864-36.919-20.562-53.719c-6.699-16.8-13.337-32.743-19.938-47.844
			c-6.601-15.1-13.326-29.852-20.125-44.25C128.408,0,83.719,0,83.719,0z M105.031,47.094c1.202,3.003,2.782,7.112,4.781,12.312
			s4.362,11.201,7.062,18c2.701,6.799,5.531,14.3,8.531,22.5c3,8.2,6.114,16.81,9.312,25.812H75.625
			c3.198-9.003,6.337-17.612,9.438-25.812c3.1-8.2,5.962-15.701,8.562-22.5s4.907-12.8,6.906-18S104.03,50.097,105.031,47.094z"
        />

        {/* стрелка — развёрнута на 180°, теперь смотрит вверх (было вниз) */}
        <path
          transform="rotate(180, 345.56, 230.22)"
          d="M323.062,78c-1.963,0-3.924,1.086-5.312,2.938s-2.187,4.445-2.188,7.062v186l-27.281-27.281
			c-1.833-1.832-4.44-2.882-7.031-2.844c-2.493,0.039-4.955,1.082-6.719,2.844l-27.5,27.5c-1.8,1.8-2.844,4.329-2.844,6.875
			s1.043,5.075,2.844,6.875l91.656,91.625c1.8,1.8,4.329,2.844,6.875,2.844s5.075-1.043,6.875-2.844l91.625-91.625
			c1.8-1.8,2.875-4.329,2.875-6.875s-1.075-5.075-2.875-6.875l-27.5-27.5c-1.799-1.796-4.302-2.844-6.844-2.844
			s-5.076,1.048-6.875,2.844L375.561,274V88c0-2.618-0.799-5.211-2.188-7.062s-3.349-2.937-5.312-2.938H323.062z"
        />

        {/* нижняя фигура */}
        <path
          d="M29.125,239.969v39.312h93.281c-7.8,9.4-16.243,20.036-25.344,31.938c-9.1,11.902-18.046,24.208-26.844,36.906
			s-17.241,25.281-25.344,37.781c-8.102,12.5-14.966,23.858-20.562,34.062v27.906h163.5v-39.312H81.906
			c7.202-12,15.424-24.582,24.625-37.781s18.507-26.007,27.906-38.406c9.399-12.399,18.483-23.842,27.281-34.344
			c8.798-10.501,16.41-19.058,22.812-25.656v-32.406H29.125L29.125,239.969z"
        />
      </g>
    </svg>
  );
}
